// GEGENEREERD door scripts/builtin-audio.mjs; niet met de hand wijzigen.
// Ingebouwde opname `builtin_a` (DESIGN §8.GB.8, docs/LICENSES.md): omgezet naar AAC en MP3,
// mono, loudness-genormaliseerd (gemeten -16.0 LUFS); verder niet bewerkt.
/** `builtin_a`: "Beautiful adhan" van Wikimedia Commons (CC0 1.0). */
export const BUILTIN_A_ASSET = {
    m4a: {
        path: '/a/4fd0d321ccd67956.m4a',
        sha256: '4fd0d321ccd67956a379e72324515df680b9ad910e82ae9ba79bc8271ea7ce33',
        bytes: 961215,
    },
    mp3: {
        path: '/a/1ab4de547168e43d.mp3',
        sha256: '1ab4de547168e43d84563ebab9ef004db2c9f7c035152dd99fd451a1714af5f1',
        bytes: 1078535,
    },
    durationS: 154,
    source: {
        title: 'Beautiful adhan',
        page: 'https://commons.wikimedia.org/wiki/File:Beautiful_adhan.ogg',
        file: 'https://upload.wikimedia.org/wikipedia/commons/b/b0/Beautiful_adhan.ogg',
        author: 'Adam-synagda',
        date: '2022-04-29',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        sha1: 'a1fa4fd942401922c5c3301816384aae86956522',
    },
};
//# sourceMappingURL=builtinAssets.js.map